export class FUITree {
    public parent: FUITree;
    public icon: string;
    public id: string;
    public selected: boolean;
    public open: boolean;
    public title: string;
    public data: any;
    public trees: FUITree[];

    public addChildNode(child: FUITree) {
        child.parent = this;
        this.trees.push(child);
    }

    constructor(tree?: any) {
        this.icon = tree && tree.icon || null;
        this.id = tree && tree.id || null;
        this.selected = tree && tree.selected || null;
        this.open = tree && tree.open || false;
        this.title = tree && tree.title || null;
        this.trees = tree && tree.trees && <FUITree[]>Array.from(tree.trees) ||  new Array<FUITree>();
        this.parent = tree && tree.parent || null;
        this.data = tree && tree.data || null;
    }
}
